import { createUseStyles } from 'react-jss'

import { colors } from '../../theme'


export default createUseStyles({
  container: {
    textAlign: 'center',
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    '& > *': {
      margin: 0,
    },
    '& > * + *': {
      marginTop: '1rem',
    },
    '& + &': {
      marginTop: '2rem',
    },
  },
  button: {
    minWidth: '15rem',
  },
  skiplink: {
    display: 'inline-flex',
    paddingBottom: '0.5rem',
    borderBottom: `1px solid ${colors.pureWhite}`,
    fontSize: '1.2rem',
    lineHeight: 1.3,
    color: colors.pureWhite,
  },
})
